module.exports = __webpack_public_path__ + "img/sel__robot.61f41a41.svg";